export function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function randomLetter(exclude) {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let c;
  do { c = letters[Math.floor(Math.random() * 26)]; } while (c === exclude);
  return c;
}

export function brightenHex(hex) {
  // AFRAME.THREE is set by 'import aframe' in main.js — always available when
  // this function is called (functions are called at runtime, not import time).
  const { THREE } = AFRAME;
  const c = new THREE.Color(hex);
  const hsl = {};
  c.getHSL(hsl);
  c.setHSL(hsl.h, hsl.s, Math.min(1.0, hsl.l + 0.3));
  return '#' + c.getHexString();
}

export function disposeLetterEntity(el) {
  const mesh = el.getObject3D('mesh');
  if (mesh) {
    mesh.geometry && mesh.geometry.dispose();
    // material and font atlas are shared across all letter entities — do not dispose
  }
  el.parentNode && el.parentNode.removeChild(el);
}

export function refreshAllRaycasters(sceneEl) {
  sceneEl.querySelectorAll('[raycaster]').forEach(function (re) {
    if (re.components && re.components.raycaster) {
      re.components.raycaster.refreshObjects();
    }
  });
}
